<div class="h-100 d-flex flex-column">
  <app-title class="flex-shrink-0"></app-title>
  
	<div class="flex-grow-1" style="overflow: auto; min-height: 0">
		<app-column-list [objects$]="insurers$" [textProperty]="properyToDisplay" (clickObject)="onClickInsurer($event)"></app-column-list>
	</div>

	<div class="row mt-3 flex-shrink-0">
		<div class="col">
			<app-btn [dataTxt]="'BACK'" (callback)="onClickRetour()" [icon]="'chevron-left'" [iconLocation]="'left'"></app-btn>
		</div>
	</div>
</div>
